module.exports = __webpack_public_path__ + "img/706962_24211E_BCB6AF_ACA494-256px.98c14a10.png";